
import {AutogenLayoutIsoScoreQuickInfo} from "./autogen/AutogenLayoutIsoScoreQuickInfo";
import {LMEUserSettings} from "@mcleod/general";
import {Api} from "@mcleod/core";
export class IsoScoreQuickInfo extends AutogenLayoutIsoScoreQuickInfo{

    sourceCarriersForAssignmentOnDisplay(event) {
        if(this.mainDataSource?.activeRow) {
            this.isoCarrierLabel.visible = this.mainDataSource.activeRow?.get("show_iso_icon");
            if (this.isoCarrierLabel.visible) {
                Api.search("lme/powerbroker/carrier-scorecard",
                    {
                        "vendor_id": "I",
                        "dot_number": this.mainDataSource.activeRow?.get("dot_number"),
                        "mc_number": this.mainDataSource.activeRow?.get("icc_number")
                    }).then((response) => {
                    this.isoCarrierLabel.link = response?.data?.[0]?.iso_portal_url;
                })
            }
        }
    }
}
